import { Injectable } from '@angular/core';
import { HttpService } from './';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class PdfSaveService {

  constructor(private http: HttpService) { }

  generateAndUploadPDF(id: any, el?: HTMLElement): void {
    if (!el) return console.error('Ticket element not found');
    const headerContainer = document.createElement('div');
    // headerContainer.innerHTML = headerHTML;
    headerContainer.style.position = 'fixed';
    headerContainer.style.top = '-10000px';
    document.body.appendChild(headerContainer);
    html2canvas(headerContainer, { scale: 2, useCORS: true, //  backgroundColor: '#fff',
      allowTaint: true,
      logging: false }).then(headerCanvas => {
      const headerImgData = headerCanvas.toDataURL('image/jpeg', 0.8);
      document.body.removeChild(headerContainer);
      html2canvas(el, { scale: 2, useCORS: true, // backgroundColor: '#fff',
      allowTaint: true,
      logging: false }).then(ticketCanvas => {
          const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
          const marginX = 8;
          const marginTop = 0;
          const marginBottom = 30;
          
          const pageWidth = pdf.internal.pageSize.width - marginX * 2;
          const pageHeight = pdf.internal.pageSize.height - marginTop - marginBottom;
  
          const headerHeight = 8; // height of header image
          const contentHeightPx = Math.floor(ticketCanvas.width * (pageHeight / pageWidth));
          let renderedHeight = 0;
  
          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d')!;
          pageCanvas.width = ticketCanvas.width;
          
          while (renderedHeight < ticketCanvas.height) {
            const sliceHeight = Math.min(contentHeightPx, ticketCanvas.height - renderedHeight);
            pageCanvas.height = sliceHeight;
            pageCtx.clearRect(0, 0, pageCanvas.width, sliceHeight);
            pageCtx.drawImage(
              ticketCanvas,
              0, renderedHeight, ticketCanvas.width, sliceHeight,
              0, 0, ticketCanvas.width, sliceHeight
            ); 
            const slicedImageData = pageCanvas.toDataURL('image/jpeg', 0.2);
            const finalImageHeight = (sliceHeight * pageWidth) / ticketCanvas.width;  
            // 🖼️ Add header
            pdf.addImage(headerImgData, 'JPEG', marginX, marginTop, pageWidth, headerHeight);
            pdf.addImage(
              slicedImageData,
              'JPEG',
              marginX,
              marginTop + headerHeight + 1,
              pageWidth,
              finalImageHeight
            );
            // 📄 Footer at the bottom
            const footerText = `Powered by Belairtrip.com | All Rights Reserved | ${new Date().toLocaleString('en-IN', {
              day: '2-digit', month: 'short', year: 'numeric',
              hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
            })}`;
            pdf.setFontSize(8);
            pdf.text(footerText, marginX, pdf.internal.pageSize.height - 4); 
            renderedHeight += sliceHeight;
            if (renderedHeight < ticketCanvas.height) {
              pdf.addPage();
            }
          }
        const blob = pdf.output('blob');
        if (blob.size > 1024 * 1024)
        console.warn(`PDF > 1MB: ${(blob.size / 1024 / 1024).toFixed(2)} MB`);
        const formData = new FormData();
        formData.append('bookingId', id);
        formData.append('pdf', blob, 'booking.pdf');
        this.http.flightsave('b2c/airCart/svPDF', formData).subscribe({
          next: res => console.log('PDF uploaded', res),
          error: err => console.error('Upload error', err)
        });
      });
    });
  }
}
